module.exports = __webpack_public_path__ + "static/media/logo-inverted.8ead9337.svg";